import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthContext } from "../Authorisation/AuthContext";
import { useContext, useEffect, useState } from "react";
import NavBar from "./NavBar";
import { APIContext, DialogAction } from "../Contexts/APIContext";
import DropDownViewModel from "../Utilities/ViewModels/DropDownViewModel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CopyrightIcon from '@mui/icons-material/Copyright';
import Tooltip from "@mui/material/Tooltip";

type DebugDatabase = {
    environment: string;
};

export default function TitleBar() {
    const { authenticated } = useContext(AuthContext);
    const { get, version, setVersion, openDialog } = useContext(APIContext);
    const [versions, setVersions] = useState<DropDownViewModel[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    const [debugDatabase, setDebugDatabase] = useState<DebugDatabase | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (authenticated) {
            get('HomePage', 'GetVersionDropdown', (data) => {
                setVersions(data.results);
                if (version === -1) {
                    setVersion(data.id);
                }
            });
        }
    }, [authenticated]);

    useEffect(() => {
        if (!authenticated) {
            setDebugDatabase(null);
            return;
        }

        const controller = new AbortController();

        fetch('/api/Debug/database', {
            credentials: 'include',
            signal: controller.signal
        }).then(response => {
            if (response.ok) {
                return response.json();
            }

            return null;
        }).then(data => {
            if (data) {
                setDebugDatabase(data);
            }
        }).catch(error => {
            if (error.name !== 'AbortError') {
            }
        });

        return () => controller.abort();
    }, [authenticated]);

    const handleVersionChange = (event) => {
        openDialog(<Typography>Changing version will take you to the home page, do you want to continue?</Typography>, [
            new DialogAction("Confirm", () => {
                const selectedVersion = event.target.value as number;
                setVersion(selectedVersion);
                navigate("/home")
            }
            )]);
    }



    return (
        <Box display="flex" flexDirection="column" height="100vh" overflow="hidden">
            <AppBar position="static" elevation={0}>
                <Toolbar variant="dense">
                    <Box component="img" src="/trics_white.png" sx={{ height: '48px' }} />
                    <Tooltip title="Database Rights" placement="bottom">
                        <IconButton onClick={() => setOpen(true)} sx={{ color: 'white' }}>
                            <CopyrightIcon />
                        </IconButton>
                    </Tooltip>
                    {authenticated && versions.length > 0 &&
                        <Select
                            value={version}
                            onChange={handleVersionChange}
                            variant="standard"
                            margin="dense"
                            sx={{ color: 'white', marginLeft: '12px' }}
                        >
                            {versions.map((version) => (
                                <MenuItem key={version.id} value={version.id}>{version.label} {version.data == true ? " - Future Version" : ""}</MenuItem>
                            ))}
                        </Select>
                    }
                    {debugDatabase &&
                        <Chip
                            label={`Database: ${debugDatabase.environment}`}
                            color={debugDatabase.environment === 'PROD'
                                ? 'error'
                                : debugDatabase.environment === 'TEST'
                                    ? 'success'
                                    : 'warning'}
                            size="small"
                            sx={{ marginLeft: '12px' }}
                        />
                    }
                    <Box component="div" sx={{ flexGrow: 1 }} />
                    {authenticated && <NavBar />}
                </Toolbar>
            </AppBar>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>Intellectual Property Rights</DialogTitle>
                <DialogContent>
                    <Typography>
                        The survey data, graphs and all associated supporting information, contained within the TRICS Database are created and published by TRICS Consortium Limited ("the Company") and the Company claims copyright and database rights in this published work. Use of this data is restricted to current TRICS licence holders and those using the TRICS Bureau Service. Licence holders may publish data from the TRICS Database in accordance with the TRICS licence. TRICS data, or extracts of TRICS data, should only be provided to third parties as part of a complete planning application document or in accordance with the Company's Bureau Services or the members' terms of licence. Data should not be attained by copying extracts from previously published reports or other documents. Any use, publication or distribution of data owned by the Company, whether obtained from the TRICS Database or from third party operated planning portals, without the Company's authorisation or a valid TRICS licence (other than in accordance with the Company's Bureau Service), will infringe the Company's intellectual property rights in the data. Please be aware that any unauthorised use of data contained in online planning portals may constitute a breach of the third party's terms of use and/or an infringement of its intellectual property rights.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Box overflow="hidden" flexGrow={1}>
                <Outlet />
            </Box>
        </Box >
    );
}